<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-medium">Response Word Limit</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <div class="border-l-2 border-gray-300 pl-4">
          <v-skeleton-loader
            v-if="isLoading"
            type="list-item-two-line"
            class="mt-2"
          ></v-skeleton-loader>
          <v-radio-group v-model="selected" column>
            <div class="d-flex align-center justify-space-between">
              <v-radio label="8 – 12 words" :value="[8, 12]"></v-radio>
              <span @click="showSample([8, 12])" class="sample-link"
                >Sample</span
              >
            </div>
            <div class="d-flex align-center justify-space-between">
              <v-radio label="12 – 20 words" :value="[12, 20]"></v-radio>
              <span @click="showSample([12, 20])" class="sample-link"
                >Sample</span
              >
            </div>
            <div class="d-flex align-center justify-space-between">
              <v-radio label="20 – 40 words" :value="[20, 40]"></v-radio>
              <span @click="showSample([20, 40])" class="sample-link"
                >Sample</span
              >
            </div>
            <div class="d-flex align-center justify-space-between">
              <v-radio label="40 – 80 words" :value="[40, 80]"></v-radio>
              <span @click="showSample([40, 80])" class="sample-link"
                >Sample</span
              >
            </div>
          </v-radio-group>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="isLoading" @click="submit"
          >Submit</v-btn
        >
      </v-card-actions>
    </v-card>

    <!-- Sample Preview Dialog -->
    <!-- Sample Preview Dialog -->
    <v-dialog v-model="showSampleDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6 font-weight-medium">Sample Responses</span>
        </v-card-title>

        <v-card-text>
          <div class="mb-4">
            <div
              v-for="(sample, index) in currentSamples"
              :key="index"
              class="mb-3"
            >
              <strong class="mr-2">•</strong><span>{{ sample }}</span>
            </div>
          </div>

          <div class="mb-1">
            <small class="text-caption text-gray-600">
              <strong>Note:</strong> Customer and Brand Name will also be
              considered in the response.
            </small>
          </div>
        </v-card-text>

        <v-card-actions class="px-4">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showSampleDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "@/utils/firebase.utils";

export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      dialog: this.value,
      selected: [12, 20],
      currentSamples: [],
      showSampleDialog: false,
      isLoading: true,
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) this.fetchWordLimitSetting();
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    showSample(range) {
      const samples = {
        "8,12": [
          "Thank you for your support. We appreciate your feedback.",
          "We're happy you had a good experience. Thanks again!",
          "Grateful for your kind words. Looking forward to seeing you again!",
        ],
        "12,20": [
          "Thanks for your review. We're glad you had a great experience with us!",
          "We're happy to hear you enjoyed your experience. Thank you for choosing us and sharing this.",
          "Your kind words mean a lot to us. We're delighted you had a great experience. Thank you so much!",
        ],
        "20,40": [
          "We truly appreciate your thoughtful feedback. It motivates us to continue delivering quality service. Thank you for choosing us!",
          "Thank you so much for your encouraging review. Your satisfaction is our top priority, and we're glad we could meet your expectations. Looking forward to serving you again soon!",
          "Thank you for taking the time to leave such positive feedback. It’s great to know we delivered a satisfying experience. Your support means a lot to us. We hope to see you again very soon!",
        ],
        "40,80": [
          "We are truly grateful for your kind words and positive review. It means a great deal to us that you had a pleasant experience. We aim to consistently meet expectations and we’re thrilled we could do that for you today.",
          "Thank you for your generous feedback. It’s always rewarding to know our efforts are appreciated. We’re committed to maintaining this level of service and ensuring that every visit is just as enjoyable as the last. Your support encourages us to keep improving. Looking forward to welcoming you again soon!",
          "We deeply appreciate your thoughtful and positive review. It's incredibly motivating to hear that your experience with us was smooth, enjoyable, and satisfactory. Our team works hard to provide consistent service, and feedback like yours helps affirm our efforts. We’re thankful for your support and look forward to serving you again in the future.",
        ],
      };
      this.currentSamples = samples[`${range[0]},${range[1]}`] || [];
      this.showSampleDialog = true;
    },
    async fetchWordLimitSetting() {
      try {
        this.isLoading = true;
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        const docSnap = await getDoc(workspaceRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const lengthSetting = data.gmb_auto_respond_length;

          if (
            Array.isArray(lengthSetting) &&
            lengthSetting.length === 3 &&
            typeof lengthSetting[0] === "number"
          ) {
            const avg = Math.round((lengthSetting[0] + lengthSetting[2]) / 2);
            if (avg <= 12) this.selected = [8, 12];
            else if (avg <= 20) this.selected = [12, 20];
            else if (avg <= 40) this.selected = [20, 40];
            else this.selected = [40, 80];
            console.log("reached hre for length0");
          } else {
            this.selected = [12, 20];
          }
        }
      } catch (error) {
        console.error("Failed to fetch word limit setting:", error);
        this.selected = [12, 20];
      } finally {
        this.isLoading = false;
      }
    },
    getRangeArray(range) {
      const map = {
        "8,12": [8, 10, 12],
        "12,20": [12, 16, 20],
        "20,40": [20, 30, 40],
        "40,80": [40, 60, 80],
      };
      return map[`${range[0]},${range[1]}`] || [12, 16, 20];
    },
    async submit() {
      try {
        const newRange = this.getRangeArray(this.selected);
        const workspaceRef = doc(
          db,
          "users",
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        await updateDoc(workspaceRef, {
          gmb_auto_respond_length: newRange,
        });
        this.$emit("submitted", newRange);
        this.dialog = false;
        this.$snackbar?.show("Word limit setting updated successfully");
      } catch (error) {
        console.error("Failed to update word limit:", error);
        this.$alert?.show("Failed to update word limit setting");
      }
    },
  },
};
</script>
<style scoped>
.sample-link {
  color: #1976d2;
  cursor: pointer;
  margin-right: 16px;
}
.sample-link:hover {
  text-decoration: underline;
}
</style>
